import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import { styles } from '../../styles';
import { useQueryClient } from '@tanstack/react-query';
import { IIntelliHrData, ICustomField } from '../../../types';
import NoCustomFields from './components/NoCustomFields';

export default function PersonCustomFields({
  renderCustomFields
}: {
  renderCustomFields: (field: ICustomField, type: 'person' | 'job') => React.ReactNode;
}) {
  const queryClient = useQueryClient();
  const intelliHrData = queryClient.getQueryData<IIntelliHrData>(['intelliHr data']);
  const queryState = queryClient.getQueryState(['intelliHr data']);
  const loadingIntelliHrData = queryState?.fetchStatus === 'fetching';

  return (
    <>
      <Stack sx={styles.cognologySectionTitle}>Person custom fields</Stack>
      {loadingIntelliHrData ? (
        <Stack sx={{ rowGap: 1 }}>
          {[...Array(5)].map((_, index) => (
            <Skeleton animation="wave" height={45} key={index} />
          ))}
        </Stack>
      ) : (
        <>
          {intelliHrData?.intellihr_data.person_custom_fields.length ? (
            <Stack sx={styles.customFieldsContainer}>
              {intelliHrData?.intellihr_data.person_custom_fields.map((field) =>
                renderCustomFields(field, 'person')
              )}
            </Stack>
          ) : (
            <NoCustomFields />
          )}
        </>
      )}
    </>
  );
}
